export const BLOCK_TYPE = {
    SIZE_CHART: "chart",
    TABLE: "table",
    TEXT: "text",
    IMAGE: "image",
    VIDEO: "video",
    DIVIDER: "divider"
}
